import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Link } from '@material-ui/core'

import DownloadIcon from '@src/icons/DownloadIcon'
import { useProductFromQueryParam } from './ProductsConfiguration'
import { useUserSession } from '@src/utils/useUserSession'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => {
  return {
    icon: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(-0.5),
      marginRight: theme.spacing(1),
    },
    text: {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(1),
    },
    link: {
      '&:hover': {
        background: 'none',
        textDecoration: 'underline',
      },
    },
    stroke: {
      stroke: theme.palette.primary.main,
      strokeWidth: '1px',
    },
  }
})

interface DownloadTemplateProps {
  label: string
  isPcr: boolean
  productType?: string
  url?: string
  product?: string
}

const DownloadTemplate: React.FC<DownloadTemplateProps> = ({
  label,
  isPcr,
  productType,
  url: downloadUrl,
  product: productName,
}) => {
  const classes = useStyles()
  const { userSession } = useUserSession()
  const { isCustomerServiceRep, isCustomProductCSR } = useCurrentUser()
  const countryCode = userSession.country
  const product = productName ?? useProductFromQueryParam()

  const url =
    downloadUrl ??
    `/configurator-upload/bulk-entry/template/${productType || product}/${countryCode}?isCSR=${isCustomerServiceRep}&isCSRSupervisor=${isCustomProductCSR}&isPCR=${isPcr}
  `

  return (
    <div>
      <Link href={url} className={classes.link} download>
        <DownloadIcon className={clsx(classes.icon, classes.stroke)} />
        <span className={classes.text}>{label}</span>
      </Link>
    </div>
  )
}

export default DownloadTemplate
